import log from 'salvo-lite/log'
import Rellax from 'rellax'

class Parallax {
    constructor (theme, elem) {
        this.elem = elem
        this.options = Object.assign({
            speed: 2,
            center: true,
            round: false,
            vertical: true,
            horizontal: false,
            percentage: 1
        }, JSON.parse(this.elem.dataset.parallax ? this.elem.dataset.parallax : '{}'))
        log.debug(this.constructor.name, 'Constructed', this)
    }

    onInit () {
        if (window.innerWidth > 1024) {
            Rellax(this.elem, this.options)
        }
    }
}

export default Parallax



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Parallax.js